import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fromFullName' })
export class FromFullNamePipe implements PipeTransform {
  transform(fullName: string, flag: 'firstName' | 'lastName' = 'firstName'): any {
    const result = fullName.split(', ');
    const firstName = result[0];
    const lastName = result[1];

    if (flag === 'firstName') {
      return firstName;
    } else if (flag === 'lastName') {
      return lastName;
    }
  }
}
